import api from './api'
const basePath =  '/api/v1/sales'

const  SaleService = {
    createSale: async (data) =>{
        try {
            console.info(data)
            const response = await api.post(`${basePath}/`, data)
            if (response.status === 201)
                return true
            return false
        } catch (error) {
            throw error
        }
    }
}


export default SaleService